module.exports = __webpack_public_path__ + "static/img/company-component-cove-10-4.4acb5c03.jpg";